module.exports = __webpack_public_path__ + "static/media/run-buddy.1c50b14e.jpg";